// extracted by mini-css-extract-plugin
export var firstSection = "firstSection-module--firstSection--29ViB";
export var firstSectionWrap = "firstSection-module--firstSectionWrap--30t7-";
export var title = "firstSection-module--title--3lzgB";
export var description = "firstSection-module--description--T1yXY";
export var galery = "firstSection-module--galery--14TBA";
export var smallImg = "firstSection-module--smallImg--2T9Qn";
export var bigImg = "firstSection-module--bigImg--1GMLo";
export var descriptionWrap = "firstSection-module--descriptionWrap--1OfP5";